<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner :background="info.image ? info.image.url : ''" :title="!pgLoading ? $t('app.carts') : ''"
      :subtitle="!pgLoading ? $t('app.carts') : ''">
    </Banner>

    <!--donation-form-area start-->
    <section class="donation-form-area-02 grey-bg2 pt-50 pb-50">
      <div class="container">
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-xl-7 col-lg-7 col-md-12">
            <div class="donation-form-left">
              <div class="donar-information donation-form white-bg mb-30 wow fadeInUp2 animated" data-wow-delay=".1s">
                <div class="section-title text-left mb-50">
                  <h2 :style="$i18n.locale == 'en' ? 'text-align:left !important' : ''
                    ">
                    {{ $t("cart.payment_method") }}
                  </h2>
                </div>

                <!-- payment methods -->
                <div class="cc-selector">
                  <div v-for="method in paymentMethods" :key="method.PaymentMethodId"
                    style="display: inline-block; margin: 5px">
                    <input :id="'payment_' + method.PaymentMethodId" type="radio" :value="method.PaymentMethodId"
                      :checked="row.payment_method == method.PaymentMethodId
                          ? true
                          : false
                        " @change="pamyentMethod(method.PaymentMethodId)" name="payment_method" />
                    <label class="payment-item" :for="'payment_' + method.PaymentMethodId">
                      <img :src="method.ImageUrl" width="50px" loading="lazy" :alt="method.PaymentMethodEn" />
                      <span class="payment-method-name">
                        {{
                          $i18n.locale == "ar"
                            ? method.PaymentMethodAr
                            : method.PaymentMethodEn
                        }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="donar-information donation-form white-bg mb-30 wow fadeInUp2 animated" data-wow-delay=".1s">
                <div class="section-title text-left mb-50">
                  <h2 :style="$i18n.locale == 'en' ? 'text-align:left !important' : ''
                    ">
                    {{ $t("cart.donation_info") }}
                  </h2>
                </div>
                <ul class="nav nav-tabs mb-15" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab"
                      aria-controls="home" aria-selected="true">{{ $t("cart.donation_info") }}</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab"
                      aria-controls="profile" aria-selected="false">{{ $t("cart.good_man") }}</a>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <div class="row payment-inner">
                      <form action="#">
                        <div class="row">
                          <div class="col-xl-6">
                            <div class="input-area mb-30">
                              <input type="text" class="form-control" v-model="row.name"
                                :placeholder="$t('contact.name')" />
                            </div>
                          </div>
                          <div class="col-xl-6">
                            <!-- <div class="input-area mb-30">
                              <input
                                type="text"
                                class="form-control"
                                v-model="row.mobile"
                                :placeholder="$t('contact.mobile')"
                                required
                              />
                            </div> -->
                            <div class="input-area mb-30">
                              <vue-tel-input class="form-control" v-model="row.mobile"
                                :placeholder="$t('contact.mobile')" :defaultCountry="'KW'"
                                v-on:country-changed="countryChanged" style="
                                  direction: ltr !important;
                                  text-align: left !important;
                                " required maxlength="14" min="4">
                              </vue-tel-input>
                            </div>
                          </div>
                          <div class="col-xl-6">
                            <div class="input-area mb-30">
                              <input type="text" class="form-control" v-model="row.email"
                                :placeholder="$t('contact.email')" />
                            </div>
                          </div>
                          <div class="col-xl-6">
                            <div class="input-area mb-30">
                              <input type="text" class="form-control" v-model="row.notes"
                                :placeholder="$t('contact.notes')" />
                            </div>
                          </div>
                          <!-- <div class="col-xl-6"> -->
                          <!-- <div class="input-area mb-30">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="البلد"
                                />
                              </div> -->
                          <!-- </div> -->
                          <div class="col">
                            <div class="input-area mb-30">
                              <input id="invoice" type="checkbox" />
                              <label class="mx-1" for="invoice">
                                {{ $t("cart.want_email") }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <p>
                      {{ $t("cart.good_man_detail") }}
                    </p>
                    <div class="col-xl-12">
                      <!-- <div class="input-area mb-30">
                    <input
                      type="phone"
                      class="form-control"
                      v-model="row.mobile"
                      :placeholder="$t('contact.mobile')"
                      required
                      max="14"
                      min="4"
                    />
                  </div> -->
                      <div class="input-area mb-30">
                        <vue-tel-input class="form-control" v-model="row.mobile" :placeholder="$t('contact.mobile')"
                          :defaultCountry="'KW'" v-on:country-changed="countryChanged" style="
                            direction: ltr !important;
                            text-align: left !important;
                          ">
                        </vue-tel-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="payment-inner mt-4">
                  <button class="theme_btn theme_btn_bg" @click="submit()">
                    {{ $t("cart.go_to_payment") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl-5 col-lg-5 col-md-12">
            <div class="details-right-area">
              <div class="widget white-bg mb-30">
                <div class="widget-post">
                  <h3 class="cases-title mb-30">{{ $t("cart.title") }}</h3>

                  <div v-for="(row, index) in rows" :key="index" class="post d-flex align-items-center mb-20">
                    <a class="mx-2" href="javascript:;" @click="
                      row.loading = true;
                    deleteCart(row.id);
                    ">
                      X
                    </a>
                    <div class="post__thumb mr-20">
                      <img v-if="row.image" alt="basket" loading="lazy" style="width: 110px; height: 100px"
                        :src="row.image" />
                      <img v-if="!row.image" alt="basket" style="
                          width: 110px;
                          height: 100px;
                          border: 1px solid #ddd;
                          padding: 5px;
                        " loading="lazy" src="/assets/img/logo/min-logo.png" />
                    </div>
                    <div class="post__content">
                      <h5 v-if="row.name">
                        <a href="javascript:;">{{ row.name }}</a>
                      </h5>
                      <h6 v-if="row.type">
                        <a href="javascript:;">{{ row.type.name }}</a>
                      </h6>
                      <span class="">
                        {{ row.amount }} {{ $t("cart.currency") }}</span>
                    </div>
                  </div>

                  <hr />
                  <h4 class="cart-total">
                    {{ $t("cart.total_grand") }}
                    <span> {{ totalGrand }} {{ $t("cart.currency") }} </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Cart Model -->
    <div class="modal fade cart-popup" :class="locale == 'ar' ? 'rtl' : 'ltr'" id="cart-popup" style="display: none"
      tabindex="-1" role="dialog" aria-labelledby="cart-popup" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <p><br /></p>
            </h5>
            <a href="/carts" class="close">
              <span aria-hidden="true">&times;</span>
            </a>
          </div>
          <div class="modal-body cart-popup">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="text-center">
                    <h4 style="color: black">
                      المبلغ المستحق لإجمالي عملية التبرع
                    </h4>
                    <h4 style="color: red; margin-top: 15px">
                      ( {{ totalGrand }} {{ $t("cart.currency") }} )
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-2"></div>
            <div class="col-8 text-center">
              <a v-if="href" :href="href" class="theme_btn theme_btn_bg text-center"
                style="padding: 20px 40px !important">أدفع الآن
              </a>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveDonorData } from "@/helpers/sendEvent";
import { trackCheckout } from "@/helpers/pixel";
import iziToast from "izitoast";
import { VueTelInput } from "vue-tel-input";
import { getPaymentMethods } from "@/data/paymentMethods";

export default {
  name: "Show",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    VueTelInput,
  },
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      row: {
        is_anonymous: 0,
        name: "",
        mobile: "",
        send_email: 0,
        email_address: "",
        is_paid: 0,
        payment_method: 1,
        notes: "",
        ccode: "",
      },
      locale: "ar",
      pgLoading: true,
      btnLoading: false,
      info: "",
      rows: [],
      href: "",

      currentPage: 1,
      itemsPerPage: 9,
      resultCount: 0,
      nextPage: 2,
      prevPage: 0,

      totalGrand: 0,
      popup: false,
      paymentMethods: [],
    };
  },
  mounted() {
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
    this.fetchPaymentMethods();
  },
  watch: {
    "row.mobile"(newVal) {
      // Enforce a maximum length of 14 characters
      if (newVal && newVal.length > 14) {
        this.row.mobile = newVal.slice(0, 14);
      }
    },
  },
  methods: {
    //
    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/carts",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 9,
          page: this.currentPage,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
          this.totalGrand = res.data.total_grand;

          // info
          this.info = res.data.info;

          // pagination
          this.currentPage = res.data.paginate.current_page;
          //this.itemsPerPage = res.data.paginate.per_page;
          this.resultCount = res.data.paginate.total;
          this.nextPage = res.data.paginate.next_page;
          this.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => {
          // 403 Forbidden
          // if(err.response && err.response.status == 401) {
          //    this.removeLocalStorage();
          //    this.$router.push({ name: 'login' });
          // }
        })
        .finally(() => { });
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    fetchCarts() {
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/carts",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 9,
          page: this.currentPage,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.rows = res.data.rows;
          this.totalGrand = res.data.total_grand;

          // pagination
          this.currentPage = res.data.paginate.current_page;
          //this.itemsPerPage = res.data.paginate.per_page;
          this.resultCount = res.data.paginate.total;
          this.nextPage = res.data.paginate.next_page;
          this.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => { })
        .finally(() => { });
    },

    setPage: function (pageNumber) {
      this.currentPage = pageNumber;
      this.fetchData();
    },

    openPopup() {
      let app = document.querySelectorAll("#cart-popup");
      let appx = app[app.length - 1];
      appx.classList.add("show");
      appx.style.display = "block";

      let body = document.querySelectorAll("body");
      let bodyx = body[body.length - 1];
      bodyx.classList.add("modal-open");

      let div = document.createElement("div");
      div.classList.add("modal-backdrop", "fade", "show");
      bodyx.appendChild(div);
    },

    closePopup() {
      //console.log('clicked....');

      let app = document.querySelectorAll("#cart-popup");
      let appx = app[app.length - 1];
      appx.classList.remove("show");
      appx.style.display = "";

      let body = document.querySelectorAll("body");
      let bodyx = body[body.length - 1];
      bodyx.classList.remove("modal-open");

      bodyx.removeChild(document.querySelectorAll("div.modal-backdrop"));
    },

    deleteCart: function (id) {
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/carts/" + id,
        method: "DELETE",
        data: {},
        params: {},
      };
      this.$axios(options)
        .then(() => {
          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.deleted_msg"),
          });
          window.location.reload();
        })
        .catch((err) => {
          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: err.response ? this.$t("app.error_contact_us") : "" + err,
          });
        })
        .finally(() => {
          this.fetchCarts();
        });
    },

    submit() {
      // condition mobile required in regular donor
      // document.getElementById("home-tab").classList.contains("active")
      if (this.row.mobile == "") {
        this.btnLoading = false;

        return iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.error_phone_required"),
        });
      }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const donorEmail = (this.row.email || this.row.email_address || "").trim();
      const donorName = (this.row.name || "").trim();
      const donorMobile = (this.row.mobile || "").trim();
      const donorCcode = (this.row.ccode || "+965").trim();

      if (donorMobile) {
        localStorage.setItem("donor_mobile", donorMobile);
      }
      if (donorCcode) {
        localStorage.setItem("donor_ccode", donorCcode);
      }
      if (donorEmail && donorEmail.includes("@")) {
        localStorage.setItem("donor_email", donorEmail);
      }
      if (donorName) {
        localStorage.setItem("donor_name", donorName);
      }

      const donorInfo = {
        mobile: donorMobile,
        ccode: donorCcode,
        email: donorEmail,
        name: donorName,
      };

      const donorData = resolveDonorData(donorInfo);
      // trackCheckout fires browser pixel + CAPI for InitiateCheckout & AddPaymentInfo.
      const checkoutData = trackCheckout(
        {
          value: this.totalGrand,
          currency: "KWD",
          content_ids: (this.rows || []).map((item) => item.id),
          content_type: "carts",
          num_items: (this.rows || []).length || 1,
          payment_method: this.row.payment_method,
        },
        { ...donorData }
      );
      const initEventId =
        (checkoutData && (checkoutData._eventId || checkoutData.event_id)) ||
        donorData.external_id ||
        null;

      const options = {
        url: window.baseURL + "/donations",
        method: "POST",
        data: {
          is_anonymous: this.row.is_anonymous,
          name: donorData.name,
          first_name: donorData.first_name,
          last_name: donorData.last_name,
          mobile: donorData.mobile,
          ccode: donorData.ccode,
          send_email: this.row.send_email,
          email_address: donorData.email,
          email: donorData.email,
          is_paid: this.row.is_paid,
          payment_method: this.row.payment_method,
          total: this.totalGrand,
          itemName: this.row.itemName,
          currency: "KWD",
          notes: this.row.notes,
          carts: true,

          event_id: initEventId,
          fbc: donorData.fbc,
          fbp: donorData.fbp,
          external_id: donorData.external_id,
        },
      };

      this.$axios(options)
        .then((res) => {
          this.btnLoading = false;
          // go to payment
          if (res.data.link) {
            setTimeout(() => {
              window.location.href = res.data.link;
            }, 250);
            // var w = window.open();
            // if( w ) {
            //   w.close();
            //   console.log('working...');
            // } else {
            //   console.log('not working...');
            // }
            //w
          } else {
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: res.response
                ? this.$t("app.error_contact_us")
                : "" + res,
            });
          }
          // iziToast.success({
          //   icon: 'ti-check',
          //   title: '',
          //   message: 'Donation Submit Successfully',
          // });
          //this.fetchCarts();
        })
        .catch((err) => {
          this.btnLoading = false;

          iziToast.warning({
            icon: "ti-alert",
            title: "",
            message: err.response ? this.$t("app.error_contact_us") : "" + err,
          });
        });
    },
    countryChanged(country) {
      this.row.ccode = country.dialCode;
    },

    changeCheck1() {
      if (this.row.is_anonymous == 1) {
        this.row.is_anonymous = 0;
      } else {
        this.row.is_anonymous = 1;
      }
    },

    changeCheck2() {
      if (this.row.send_email == 1) {
        this.row.send_email = 0;
      } else {
        this.row.send_email = 1;
      }
    },

    pamyentMethod(id) {
      this.row.payment_method = id;
    },
    async fetchPaymentMethods() {
      this.paymentMethods = await getPaymentMethods();
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
//
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
;
<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}

.vue-tel-input {
  height: 50px;
}

.vue-tel-input .vti__dropdown {
  width: 70px !important;
}

.vue-tel-input .vti__dropdown-arrow {
  width: 50px !important;
  margin-top: -10px !important;
  position: static !important;
}

.vti__dropdown-list,
.vti__dropdown-list.below {
  z-index: 1000 !important;
}
</style>
